import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

import srLat from 'vuetify/src/locale/sr-Latn.ts'

import themes from '@/plugins/themes.js'

const MY_ICONS = {
    close: 'fal fa-times'
};

export default new Vuetify({
    lang: {
        locales: { srLat }
    },
    theme: {
        options: {
            customProperties: true,
            variations: false
        },
        themes: themes
    },
    icons: {
        iconfont: 'fa',
        values: MY_ICONS
    }
});

// Extending Vuetify
Object.defineProperty(Vue.prototype, '$snackbar', {
    value: function(text, type = null, options = {}) {
        this.eventBus.$emit('show-snackbar', {
            text: text,
            type: type,
            options: options
        });
    }
});

Object.defineProperty(Vue.prototype, '$confirm', {
    value: function(message, options = {}, callback = () => {}) {
        this.eventBus.$emit('show-confirm', {
            message: message,
            options: options,
            callback: callback
        });
    }
});

